import { Typography, Box, Button } from "@mui/material";
import { DriveEta, PlayArrow, Close } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import GenericModal from "../GenericModal";
import { ExamAlertProps } from "../../Utils/Types";

export default function ExamAlert(props: ExamAlertProps) {
  const { open, onCancel, onConfirm } = props;
  return (
    <GenericModal
      open={open}
      onClose={onCancel}
      title=""
      actions={
        <>
          <Button
            variant="outlined"
            onClick={onCancel}
            startIcon={<Close />}
            color="error"
          >
            {Vocabulary.cancel}
          </Button>
          
          <Button
            variant="contained"
            onClick={onConfirm}
            startIcon={<PlayArrow />}
            color="primary"
          >
            {Vocabulary.start}
          </Button>
        </>
      }
    >
      <Box sx={{ textAlign: 'center', py: 2 }}>
        <Box sx={{ mb: 3 }}>
          <DriveEta 
            sx={{
              fontSize: 64,
              color: 'primary.main',
              background: 'linear-gradient(135deg, rgba(21, 101, 192, 0.1) 0%, rgba(21, 101, 192, 0.2) 100%)',
              borderRadius: '50%',
              padding: 2,
              boxShadow: (theme) => `0 4px 20px ${theme.palette.primary.main}30`
            }}
          />
        </Box>
        
        <Typography 
          variant="h5" 
          sx={{
            fontWeight: 600,
            color: 'primary.main',
            mb: 2,
            fontSize: '1.5rem'
          }}
        >
          {Vocabulary.examStartAlert}
        </Typography>
        
        <Typography 
          variant="body1" 
          sx={{
            color: 'text.secondary',
            lineHeight: 1.6,
            fontSize: '1.1rem'
          }}
        >
          {Vocabulary.examStartAlertText}
        </Typography>
      </Box>
    </GenericModal>
  );
}
